import { formatBigInt, Style } from '../../common/format_large_number'
import { type Department } from '../../../../shared/types/Department'
import constants from '../../../../shared/common/values/constants.json'

export default function Department({
	department,
	quantity,
	allowSublime,
	hideDetails,
	onClick
}: {
	department: Department
	quantity: number
	allowSublime?: boolean
	hideDetails?: boolean
	onClick?: () => void
}) {
	return (
		<div className="mb-4 flex flex-col justify-center overflow-hidden rounded-2xl border border-purple-800 bg-purple-950 p-4 backdrop-blur-sm transition-all hover:border-purple-700 hover:bg-purple-900">
			<div className="mb-2 flex items-center justify-between">
				<h3 className="text-xl font-bold text-purple-100">
					{hideDetails ? '???' : department.name}
				</h3>
				<span className="rounded-full bg-purple-700 px-3 py-1 text-sm text-purple-100">
					Level {quantity}
				</span>
			</div>
			<p className="mb-3 text-sm text-purple-200">
				{hideDetails
					? "This department hasn't been bought yet."
					: department.description}
			</p>
			<div className="relative mb-3 h-2 overflow-hidden rounded-full bg-purple-800">
				<div
					className="h-full bg-purple-400"
					style={{ width: `${quantity % 100}%` }}
				/>
			</div>
			<button
				className="w-full rounded-lg bg-purple-600 py-2 text-center font-semibold text-purple-100 transition-colors hover:bg-purple-500"
				onClick={onClick}
			>
				{allowSublime
					? 'FREE'
					: `Buy - ${formatBigInt(
							BigInt(
								Math.floor(
									department.basePrice *
										(department.priceMultiplier
											? department.priceMultiplier
											: constants.standardMultiplier) **
											quantity
								)
							),
							Style.Short
						)}`}
			</button>
		</div>
	)
}
